module.exports = __webpack_public_path__ + "static/switching-logo-bulletproof-00ecb22b52186ddbf8bf6deec5c9b9f5.svg";